export default "__VITE_ASSET__ghzldl5l__"